import { TrendingUpRounded } from '@material-ui/icons';
import React from 'react';
import { formatDate, formatValidSelect } from '../../../helpers/FormatHelper';
import { getAllBranches } from '../../../networking/NetworkingBankBranches';
import { getListOfBanks } from '../../../networking/NetworkingBanks';
import { getCountries } from '../../../networking/NetworkingCountries';
import { searchCustomerByIdNameMin } from '../../../networking/NetworkingCustomers';
import { getParametersByName } from '../../../networking/NetworkingGlobalSystemParameters';
import { getAllUsers } from '../../../networking/NetworkingUsers';
import { getStyle, notFilledInputClass, regularInputClass } from '../../../styles/styles';
import AlertBox from '../../shared/AlertBox';
import DatePicker from '../../shared/DatePicker';
import DynamicSearchSelect from '../../shared/DynamicSearchSelect';
import DynamicSelect from '../../shared/DynamicSelect';
import NumberInput from '../../shared/NumberInput';
import { newSearchCustomers } from '../../../networking/Networking';


var style = getStyle();

export default class OrderReportForm extends React.Component {

    state = {
        customerList: [],
        countryList     : [],
        bankList        : [],
        banksFiltered   : [],
        disableBank     : true,
        branchList      : [],
        branchFiltered  : [],
        disableBranch   : true,
        fields: {
            "FromDate": null,
            "ToDate": null,
            CustomerID: -1
        },
        showFields: {
            "ToDate": false,
            "FromDate": false,
            CustomerID: false
        },
        validations: {          
            fromDate: true,
            toDate: true,           
            customerSelected: true,
            errorMessage: '',
        },
        //Alert Box
        showAlertOK: false,
        alertTitle: '',
        alertMessage: '',
        userEmail: '',
        systemDate: null
    }

    componentDidMount() {        
        getParametersByName('BNSystemDate').then(
            (json) => {
                this.setState({ systemDate: json.parameters[0].Value });
            }
        );
    }

    componentDidUpdate(prevProps) 
    {
        if (!this.compare(prevProps.fields, this.props.fields)) 
        {
            var showFields = this.state.showFields;
            for (var key in showFields) 
            {
                showFields[key] = false;
            }
            for(var i = 0; i < this.props.fields.length; i++) 
            {
                let formattedString = this.props.fields[i];
                showFields[formattedString] = true;

                if (formattedString === 'CustomerID') {
                    newSearchCustomers('', 0, 0).then(
                        (jsonResponse) => {
                            console.log("newSearchCustomers: " + JSON.stringify(jsonResponse))
                            if (jsonResponse.httpStatusCode === 200) {
                                if (jsonResponse.customers !== undefined) {
                                    var tempCustomers = jsonResponse.customers
                                    var finalListOfCustomers = []
                                    tempCustomers.forEach(element => {
                                        var el = element
                                        el.value = element['Customer ID']
                                        el.name = element['Customer Name']

                                        finalListOfCustomers.push(el)
                                    });

                                    finalListOfCustomers.sort(this.dynamicSort("name"));
                                    finalListOfCustomers.splice(0,0,{value: -2, name:"All Customer"});

                                    this.setState({
                                        customerList: finalListOfCustomers
                                    });
                                }
                            }
                        }
                    );
                }
            }
            this.resetFields()
            this.setState({ showFields }, () => {
                this.props.isValid(this.validateRequiredInputs());
                this.props.getFields(this.state.fields);
            });
        }
        if (prevProps.validated !== this.props.validated && !this.props.validated ) {
            this.validateRequiredFields();
        }
        if (prevProps.forceReload !== this.props.forceReload) {
            this.resetFields();
        }
    }

    //Order una Lista por alguna propiedad [Usado en las Listas de Currencies]
    dynamicSort = (property) => {
        var sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }

        return function (a,b) 
        {
            /* next line works with strings and numbers, 
                * and you may want to customize it to your needs
            */
            //////debugger
            var x = a[property] == null ? "":a[property];
            var y = b[property] == null ? "":b[property];

            if(typeof(x) == 'string' && typeof(y) == 'string')
            {
                x = x.toLowerCase();
                y = y.toLowerCase();
            }

            var result = (x < y) ? -1 : (x > y) ? 1 : 0;
            return result * sortOrder;
        }
    }

    compare(array1, array2) {
        if (array1.length !== array2.length) {
            return false;
        }
        array1.sort();
        array2.sort();
        for (var i = 0; i< array1.length; i++) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }
        return true;
    }

    resetFields() {
        const fields = {
            "FromDate": this.state.systemDate,
            "ToDate": this.state.systemDate,        
            CustomerID: -1         
        }
        
        this.props.getFields(fields);
        this.setState({ fields: fields });
    }

    validateRequiredFields() {
        var 
            fromDate       = true, 
            toDate         = true,           
            customerSelected    = true
           

        var errorMessage = "";


        if(this.state.showFields.CustomerID)
        {
            if(this.state.fields.CustomerID === -1)
            {
                customerSelected = false;
            }
        }

        if (this.state.fields["FromDate"] !== null || this.state.fields["ToDate"] !== null) {
            if (this.state.fields["FromDate"] === null) {
                fromDate = false;
            }
            if (this.state.fields["ToDate"] === null) {
                toDate = false;
            }
            if (this.state.fields["FromDate"] !== null && this.state.fields["ToDate"] !== null) {
                let fromArray = this.state.fields["FromDate"].split("/");
                let toArray = this.state.fields["ToDate"].split("/");
                //let from = new Date(fromArray[2], fromArray[1], fromArray[0]);
                //let to = new Date(toArray[2], toArray[1], toArray[0]);
                //if (from > to) {
                if (Date.parse(fromArray) > Date.parse(toArray)) {
                    fromDate = false;
                    errorMessage = "From Date cannot be greater than To Date"
                }
            }
        }
    
        this.setState({
            validations: {
                ...this.state.validations,            
                fromDate,
                toDate,                
                customerSelected,
                errorMessage

            }
        });
    }

    validateRequiredInputs() {
        var errors = [];
        var valid = true;


       /* if(this.state.showFields.CustomerID)
        {
            if(this.state.fields.CustomerID === undefined || this.state.fields.CustomerID ===-1)
            {
                valid = false;
                errors.push("Select a Customer.");
            }
        }*/

        if (this.state.fields["FromDate"] !== null || this.state.fields["ToDate"] !== null) {
            if (this.state.fields["FromDate"] === null && this.state.fields["ToDate"] !== null) {
                valid = false;
                errors.push("To Date cannot be empty.");
            }
            else if (this.state.fields["ToDate"] === null && this.state.fields["FromDate"] !== null) {
                valid = false;
                errors.push("From Date cannot be empty.");
            }
            if (this.state.fields["FromDate"] !== null && this.state.fields["ToDate"] !== null) {
                let fromArray = this.state.fields["FromDate"].split("/");
                let toArray = this.state.fields["ToDate"].split("/");
                //let from = new Date(fromArray[2], fromArray[1], fromArray[0]);
                //let to = new Date(toArray[2], toArray[1], toArray[0]);
                //if (from > to) {
                if (Date.parse(fromArray) > Date.parse(toArray)) {
                    valid = false;
                    errors.push("From Date cannot be greater than To Date.");
                }
            }
        }
    
        return { valid, errors };
    }

    validateEmail() {
        var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/;
        if (!this.state.fields.Email.match(regex)) {
            return false;
        }
        return true;
    }
    
    formatVisibility(field) {
        return field ? "inline" : "none";
    }

    formatValidInput(valid) {
        return valid ? regularInputClass : notFilledInputClass;
    }

    searchCustomer = async (query) => {
        if (query === '') {
            const fields = {...this.state.fields, CustomerID: 0 };
            this.setState({ customerList: [], fields: fields });
            this.props.getFields(fields);
        } else {
            const json = await searchCustomerByIdNameMin(query);
            if (json != null && json.customers != null) {
                const customers = json.customers.map((c) => ({ ...c, value: c.CustomerID, name: c.CustomerIDName }));
                this.setState({ customerList: customers });
            }
        }
    };


    handleUpdateFromDate = (date) => {
        let value = date !== undefined ? formatDate(date) : '';
        this.setState({
            fields: {...this.state.fields, "FromDate": value, "ToDate": value},
            validations: {...this.state.validations, fromDate: true, toDate: true}
        },
            () => {
                this.props.isValid(this.validateRequiredInputs());
                this.props.getFields(this.state.fields);
            }
        );
    }
    
    handleUpdateToDate = (date) => {
        let value = date !== undefined ? formatDate(date) : '';
        this.setState({
            fields: {...this.state.fields, "ToDate": value},
            validations: {...this.state.validations, toDate: true}
        },
            () => {
                this.props.isValid(this.validateRequiredInputs());
                this.props.getFields(this.state.fields);
            }
        );
    }



 
    handleGetValueCustomer = (value) =>
    {
        if (value != null && value.value !== undefined) 
        {
            this.setState({
                fields: {...this.state.fields, CustomerID: value.value},
                validations: {...this.state.validations, customerSelected: true}
            }, () => {
                this.props.getFields(this.state.fields);
                this.props.isValid(this.validateRequiredInputs());
            });
        }
    }



   



    closeAlertOK = () => {
        this.setState({ showAlertOK: false, alertMessage: '', alertTitle: '' });
    }

    render() {
        return (
            <div className="uk-margin">
               
                
                <div className="uk-width-1-1 uk-form-stacked" style={{ display: this.formatVisibility(this.state.showFields["FromDate"]) }}>
                    <label className="uk-form-label" style={[style.boldLabel], { marginTop: 18 }}>From Date</label>
                    <DatePicker
                        //className={this.formatValidInput(this.state.validations.fromTradeDate)}
                        className={this.formatValidInput(true)}
                        readOnly={true}
                        value={this.state.fields["FromDate"]}
                        onDayChange={this.handleUpdateFromDate}
                    />
                </div>
                <div className="uk-width-1-1 uk-form-stacked" style={{ display: this.formatVisibility(this.state.showFields["ToDate"]) }}>
                    <label className="uk-form-label" style={[style.boldLabel], { marginTop: 18 }}>To Date</label>
                    <DatePicker
                        //className={this.formatValidInput(this.state.validations.toTradeDate)}
                        className={this.formatValidInput(true)}
                        readOnly={true}
                        value={this.state.fields["ToDate"]}
                        onDayChange={this.handleUpdateToDate}
                    />
                </div>

                {this.state.showFields.CustomerID && <div className="uk-grid">
                    <div
                        className="uk-width-1-2 uk-form-stacked"
                        style={{ display: this.formatVisibility(this.state.showFields.CustomerID), }}
                    >
                        <label className="uk-form-label" style={[style.boldLabel], { marginTop: 18 }} >Customer</label>
                        <div className="" style={style.inputStyle}>
                            <DynamicSearchSelect
                                className={this.formatValidInput(this.state.validations.customerSelected)}
                                objValue={{ value: this.state.fields.CustomerID }}
                                getValue={this.handleGetValueCustomer}
                                searchFunction={this.searchCustomer}
                                listHasPlaceholder={false}
                                data={this.state.customerList}
                                id="select-sds-customer"
                                placeholder={"Select a Customer..."}
                            />
                        </div>
                    </div>

                   
                </div>}
                
                
                <AlertBox
                    open={this.state.showAlertOK}
                    onClose={this.closeAlertOK}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    type="Ok"
                    okClick={this.closeAlertOK}
                />
            </div>
        );
    }
}